import { Alert, AlertTitle, Button, Stack } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { buildPaywallUrl } from '../../helpers/paywall';
import { usePlanQuota } from '../../helpers/planUsage';
import { quotaBlockedMessage } from './QuotaLimitedButton';

/**
 * Aviso de cota esgotada para páginas de formulário, cobrindo quem chega por
 * link direto sem passar pelo botão de criar. Retorna null quando há cota.
 */
export default function QuotaBlockedNotice({ quotaKey, backTo }) {
    const location = useLocation();
    const { blocked, entry } = usePlanQuota(quotaKey);

    if (!blocked) {
        return null;
    }

    return (
        <Alert severity="warning" sx={{ mb: 3 }}>
            <AlertTitle>Limite do plano atingido</AlertTitle>
            {quotaBlockedMessage(entry)}
            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                <Button
                    variant="contained"
                    color="warning"
                    component={RouterLink}
                    to={buildPaywallUrl({ returnTo: location.pathname })}
                >
                    Ver planos
                </Button>
                {backTo ? (
                    <Button variant="outlined" component={RouterLink} to={backTo}>
                        Voltar
                    </Button>
                ) : null}
            </Stack>
        </Alert>
    );
}

/** Conveniência para desabilitar o submit de um formulário já aberto. */
export function useQuotaBlocked(quotaKey) {
    return usePlanQuota(quotaKey).blocked;
}
